
import { defineComponent, ref } from "vue";
import { Station } from "@/types/station.type";
import { Image, SearchStation } from "@/types";
import { changeActiveStation, getStations } from "@/service/station.service";
import { DataStation } from "@/types/datastation.type";
import { Action, ElMessage, ElMessageBox } from "element-plus";
import StationConfigFormComponent from "./StationConfigForm.component.vue";
import StationFormComponent from "./StationForm.component.vue";
import StationImageComponent from "./StationImage.component.vue";
import StationImagesModalComponent from "./StationImagesModal.component.vue";
import { Filter } from "@/types/filter.type";
import moment from "moment";
import ObserverComponent from "../Observer.component.vue";
import StationSearchFormComponent from "./StationSearchForm.component.vue";
import { i18n } from "@/plugins/i18n.plugin";

interface DataItem {
  icon: string;
  index: string;
  title: string;
}
export default defineComponent({
  components: {
    StationConfigFormComponent,
    StationFormComponent,
    StationImageComponent,
    StationImagesModalComponent,
    ObserverComponent,
    StationSearchFormComponent,
  },
  setup() {
    const stationSearchForm = ref<any>();

    const items: DataItem[] = [
      {
        icon: "el-icon el-icon-wifi fas",
        index: "rssi",
        title: "magnitude.rssi",
      },
      {
        icon: "el-icon el-icon-battery-full fas",
        index: "voltage",
        title: "magnitude.voltage",
      },
      {
        icon: "el-icon el-icon-sd-card fas",
        index: "available_SD",
        title: "magnitude.available_SD",
      },
      {
        icon: "el-icon el-icon-images fas",
        index: "capture",
        title: "magnitude.capture",
      },
    ];

    return {
      items,
      stationSearchForm,
    };
  },
  data() {
    return {
      stations: [] as Station[],
      isModalImageVisible: false,
      modalTitle: "",
      images: [] as Image[] | undefined,
      stationId: "",
      active: true,
      entitySelected: undefined as Station | undefined,
      showConfigEntityForm: false,
      showEntityForm: false,
      currentPage: 1,
      maxRows: 0,
      search: undefined as SearchStation | undefined,
      hasMore: true,
      copyEntity: undefined as Station | undefined,
    };
  },
  mounted() {
    // Cargar solo estaciones activas la primera vez
    this.search = {
      query: "",
      group: "ALL",
      queryField: "ALL",
      activeStatus: "ACTIVATED",
    };
    this.getUpdate();
  },
  methods: {
    getUpdate() {
      this.refreshStations();
    },
    goBack() {
      this.$router.push("/stations");
    },
    getFilter() {
      const filter: Filter = {};

      filter.fields = {};
      switch (this.search?.queryField) {
        case "ALL":
          filter.multi = this.search.query;
          break;
        case "STATION_NAME":
          filter.fields["station.name"] = {
            operator: "contains",
            value: this.search.query,
          };
          break;
        case "STATION_STATION":
          filter.fields["station.station"] = {
            operator: "contains",
            value: this.search.query,
          };
          break;
        case "SAMPLINGPOINT_NAME":
          filter.fields["samplingPoint.name"] = {
            operator: "contains",
            value: this.search.query,
          };

          break;
        default:
          break;
      }

      if (this.search?.group) {
        if (this.search.group == "OFFICE") {
          filter.fields["station.office"] = { operator: "equal", value: true };
        } else if (this.search.group == "NO_OFFICE") {
          filter.fields["station.office"] = { operator: "equal", value: false };
        }
      }

      if (this.search?.activeStatus) {
        if (this.search.activeStatus == "ACTIVATED") {
          filter.fields["station.active"] = { operator: "equal", value: true };
        } else if (this.search.activeStatus == "DEACTIVATED") {
          filter.fields["station.active"] = { operator: "equal", value: false };
        }
      }

      return filter;
    },

    /**
     * confirm activate item
     * @param item
     */
    confirmActivateItem(item: Station) {
      ElMessageBox.confirm(
        this.$t("confirm.activateStation", { name: item.name }),
        this.$t("label.warning"),
        {
          confirmButtonText: this.$t("btn.accept"),
          cancelButtonText: this.$t("btn.cancel"),
          type: "warning",
          dangerouslyUseHTMLString: true,
          callback: (action: Action) => {
            if (action === "confirm") {
              this.changeStatusStation(item, true);
            }
          },
        }
      );
    },

    /**
     * confirm deactivate action
     * @param item
     */
    confirmDeactivateItem(item: Station) {
      ElMessageBox.confirm(
        this.$t("confirm.deactivateStation", { name: item.name }),
        this.$t("label.warning"),
        {
          confirmButtonText: this.$t("btn.accept"),
          cancelButtonText: this.$t("btn.cancel"),
          type: "warning",
          dangerouslyUseHTMLString: true,
          callback: (action: Action) => {
            if (action === "confirm") {
              this.changeStatusStation(item, false);
            }
          },
        }
      );
    },

    async showMore() {
      // - get result for current page
      this.hasMore = false;
      const rowPerPage = 10;
      const { data, totalRows } = await getStations(this.currentPage, rowPerPage, this.getFilter());

      // - concat result array
      this.stations = [...this.stations, ...data];

      // - check if exist more result
      this.hasMore = totalRows > this.currentPage * rowPerPage;
      this.currentPage++;
    },

    async refreshStations(item: Station | undefined = undefined) {
      let index = -1;
      if (this.stations && item) {
        index = this.stations.findIndex((i) => i.id === item.id);
      }
      if (index !== -1 && item) {
        this.stations[index] = item;
      } else {
        this.stations = [];
        this.currentPage = 1;
        await this.showMore();
      }
    },

    convertDateToString(dateString: string, time: string) {
      let dateTime = "-" as string | null;

      if (dateString !== "null" && time !== "null") {
        const date = new Date(`${dateString}T${time}Z`);
        dateTime = moment(date).format(this.$t("format.dateTime"));
      }
      return dateTime !== null || dateTime !== "" ? dateTime : "-";
    },
    async seeImages(station: Station) {
      if (station.station) {
        this.stationId = station.station;
        this.modalTitle = this.$t("label.imageViewer");
        this.isModalImageVisible = true;
      }
    },
    closeModalImage() {
      this.stationId = "";
      this.modalTitle = "";
      this.isModalImageVisible = false;
    },

    async deleteStation(station: Station) {
      const message = station.active
        ? this.$t("confirm.deactivateStation", { name: station.name })
        : this.$t("confirm.activateStation", { name: station.name });
      ElMessageBox.confirm(message, this.$t("label.warning"), {
        confirmButtonText: this.$t("btn.accept"),
        cancelButtonText: this.$t("btn.cancel"),
        type: "warning",
        dangerouslyUseHTMLString: true,
        callback: (action: Action) => {
          if (action === "confirm") {
            const status = station.active ? true : false;
            this.changeStatusStation(station, status);
          }
        },
      });
    },
    async changeStatusStation(station: Station, active: boolean) {
      if (!station.id) return;
      // TODO el servicio debe retornar el item
      await changeActiveStation(station.id);
      station.active = !station.active;
      // - refrehs item
      this.refreshStations(station);
      ElMessage.success(this.$t("success.action"));
    },

    /**
     * open entity form dialog
     * @param item
     */
    formEntityDialog(item: Station | undefined = undefined) {
      this.copyEntity = Object.assign({}, this.entitySelected);
      this.entitySelected = item;
      this.showEntityForm = true;
    },

    /**
     * open entity form config dialog
     * @param item
     */
    formConfigDialog(item: Station | undefined) {
      this.copyEntity = Object.assign({}, this.entitySelected);
      this.entitySelected = item;
      this.showConfigEntityForm = true;
    },

    /**
     * close samplingPoint formDialog
     */
    closeEntityDialog() {
      this.showEntityForm = false;
      this.showConfigEntityForm = false;
    },

    /**
     * save configuration
     */
    async saveConfiguration() {
      // - call stationConfigForm save method
      const station = await (
        this.$refs["stationConfigForm"] as InstanceType<typeof StationConfigFormComponent>
      ).doSave();

      // - close dialog and refresh
      this.closeEntityDialog();
      this.refreshStations(station);
      ElMessage.success(this.$t("success.action"));
    },

    /**
     * save entity
     */
    async saveEntity() {
      // - call stationConfigForm save method
      const station = await (
        this.$refs["stationForm"] as InstanceType<typeof StationFormComponent>
      ).doSave();

      // - close dialog and refresh
      this.closeEntityDialog();
      this.refreshStations(station);
      ElMessage.success(this.$t("success.action"));
    },

    generateStationDetailRoute(station: Station) {
      if (!this.$route.path.includes("stations/stations")) {
        return {
          path: `/stations/stations/${station.station}`,
        };
      }

      return {
        path: `stations/${station.station}`,
      };
    },

    seeDetail(station: Station) {
      if (!this.$route.path.includes("stations/stations")) {
        this.$router.push(`/stations/stations/${station.station}`);
      } else {
        this.$router.push(`stations/${station.station}`);
      }
    },
    /**
     * get the necessary data to display on the sensor card
     * @param stationData
     * @param magnitude
     *
     */
    getDataFromStation(stationData: DataStation[] | undefined, magnitude: string) {
      return stationData ? stationData.filter((x) => x.magnitude == magnitude)[0] : null;
    },
    /**
     * find the measurement to display on the sensor card
     * @param stationData
     * @param magnitude
     *
     */
    findMeasurement(stationData: DataStation[] | undefined, magnitude: string) {
      let data = this.getDataFromStation(stationData, magnitude);
      if (data && data !== null && data.magnitude && data.measurement) {
        if (data.magnitude === "capture") {
          if (data.measurement === "0") {
            data.measurement = "Masiva";
          } else if (data.measurement === "1") {
            data.measurement = "Continua";
          }
        } else if (data.magnitude === "available_SD" && Number(data.measurement)) {
          data.measurement = i18n.global.n(Number(data.measurement), "twoDecimals");
        } else if (Number(data.measurement)) {
          // data.measurement = data.measurement;
          data.measurement = i18n.global.n(Number(data.measurement), "fixed");
        }
      }
      return data ? data.measurement : "-";
    },
    /**
     * @param stationData
     * @param magnitude
     *
     */
    classMagnitude(stationData: DataStation[] | undefined, magnitude: string) {
      let data = this.getDataFromStation(stationData, magnitude);
      let classMagnitude = "tag-data red";
      if (data && data !== null) {
        classMagnitude = this.changeColor(data, classMagnitude);
      }
      return classMagnitude;
    },
    /**
     * Change color according to magnitude
     * @param data
     * @param classMagnitude
     */
    changeColor(data: DataStation, classMagnitude: string) {
      if (data.measurement) {
        if (data.magnitude === "voltage") {
          classMagnitude = this.classBattery(parseFloat(data.measurement), classMagnitude);
        } else if (data.magnitude === "rssi") {
          classMagnitude = this.classRSSI(parseInt(data.measurement), classMagnitude);
        } else if (data.magnitude === "available_SD") {
          classMagnitude = this.classAvailable_SD(parseInt(data.measurement));
        } else if (data.magnitude === "capture") {
          classMagnitude = "tag-data green";
        }
      }
      return classMagnitude;
    },
    classBattery(measurement: number, classMagnitude: string) {
      if (measurement > 4.1) {
        classMagnitude = "tag-data green";
      } else if (measurement <= 4.1 && measurement >= 3.8) {
        classMagnitude = "tag-data green_2";
      } else if (measurement < 3.8) {
        classMagnitude = "tag-data orange";
      }
      return classMagnitude;
    },
    classRSSI(measurement: number, classMagnitude: string) {
      if (measurement >= 0 && measurement <= 15) {
        classMagnitude = "tag-data orange";
      } else {
        classMagnitude = "tag-data green";
      }
      return classMagnitude;
    },
    classAvailable_SD(measurement: number) {
      let classMagnitude = "tag-data red";
      if (measurement <= 100 && measurement >= 20) {
        classMagnitude = "tag-data green";
      } else if (measurement < 20 && measurement > 0) {
        classMagnitude = "tag-data orange";
      }
      return classMagnitude;
    },
    classOpticalOperation(stationData: DataStation[] | undefined) {
      const data = this.getDataFromStation(stationData, "optical_operation");
      let classMagnitude = "tag green";
      if (data && data !== null && data.measurement && data.magnitude === "1") {
        classMagnitude = "tag red";
      }
      return classMagnitude;
    },
    doSearch(search: SearchStation) {
      this.search = search;
      this.refreshStations();
    },

    checkTime(lastDate: string, lasttime: string, interval: number) {
      if (lastDate !== null && lastDate !== undefined && interval !== null) {
        // Variables asignadas para calcuar la diferencia de tiempo
        let lastTime = undefined;
        let nowTime = undefined;
        let timeDiference = undefined;

        // Variables para tener en cuenta los tiempos
        let warning = 2;
        let danger = 3;

        // Calculamos la diferencia de tiempo
        let dateTime = lastDate + "T" + lasttime + "Z";
        const dateString = new Date(`${dateTime}`);
        lastTime = dateString.getTime();
        nowTime = new Date().getTime();
        timeDiference = Math.floor((nowTime - lastTime) / 1000 / 60);

        // Comprobacion de los intervalos
        if (interval < 15) {
          warning = 26;
          danger = 60;
          interval = 1;
        }

        // Comprobamos si la diferencia del tiempo pasa del tiempo establecido para el aviso
        if (timeDiference < interval * danger && timeDiference >= interval * warning) {
          return "warning";
        } else if (timeDiference >= interval * danger) {
          return "danger";
        }
      }
    },
  },
});
